import Vue from 'vue'
import { MoyenPaiement } from '@/enum/MoyenPaiement'

Vue.filter('moyenPaiement', function(value: MoyenPaiement ) {
  if (value || value === 0) {
    switch(value){       
      case MoyenPaiement.cb:
        return 'Carte bancaire'
      case MoyenPaiement.cheque:
        return 'Chèque'      
      case MoyenPaiement.virement:
        return 'Virement'    
      case MoyenPaiement.paypal:
        return 'PayPal'   
      case MoyenPaiement.cb3x:
        return 'CB 3x'        
    }        
    return ''
  }
})